/* eslint-disable react-hooks/exhaustive-deps */
import { Box, styled, Theme, Typography } from "@mui/material";
import { useEffect } from "react";
import { Col, Row } from "v2/components/base/Flex/ui";
import BasicButton from "v2/components/Buttons/BasicButton";

const EMAIL_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const EmailCheckBlocker = ({
  variant,
  onVerified,
  onClickLogout,
  isEmailValid,
  isEmailSending,
  tgUserId,
  tgUserName,
  email,
  isOtpValid,
  isOtpVerifying,
  isEmailSent,
  userEmail,
  handleOnOTPChange,
  handleSendEmail,
  handleOnEmailChange,
  handleGoBack,
  handleVerifyOTP,
}: {
  variant: "init" | "update";
  onVerified?: () => void;
  onClickLogout: () => void;
  isEmailValid: boolean;
  isEmailSending: boolean;
  tgUserId: string;
  tgUserName: string;
  email: string;
  isOtpValid: boolean;
  isOtpVerifying: boolean;
  isEmailSent: boolean;
  userEmail: string;
  handleOnOTPChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSendEmail: () => void;
  handleOnEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleGoBack: () => void;
  handleVerifyOTP: () => void;
}): JSX.Element | null => {
  return !isEmailSent ? (
    <>
      <Col
        type="cc"
        sx={{ padding: "16px", textAlign: "center", gap: "24px" }}
        fullWidth
        fullHeight>
        <Typography sx={{ maxWidth: "330px" }} variant="mobile-h2">
          {variant === "init" || !userEmail
            ? "Input Email For Recovery"
            : "Edit Email For Recovery"}
        </Typography>
        <Box
          sx={{
            textAlign: "start",
            maxWidth: "372px",
            width: "100%",
          }}>
          <Box sx={{ marginBottom: "4px" }}>
            <Typography variant="mobile-body-s" color="text.secondary">
              Email Address
            </Typography>
          </Box>
          <StyledInputV2
            key="email"
            defaultValue={email ?? ""}
            onChange={handleOnEmailChange}
            sx={{ textAlign: "start" }}
            spellCheck={false}
            autoComplete="off"
            autoCapitalize="none"
          />
        </Box>
        <Row
          type="cc"
          sx={{
            position: "relative",
            marginX: "auto",
            height: "56px",
            maxWidth: "372px",
            // paddingX: "12px",
            marginBottom: "4px",
          }}
          fullWidth>
          <BasicButton
            sx={{ width: "100%" }}
            variant={isEmailValid && !isEmailSending ? "primary" : "disabled"}
            onClick={handleSendEmail}
            disabled={!isEmailValid || isEmailSending}>
            <Typography
              variant="mobile-body-s-heavy"
              color={isEmailValid && !isEmailSending ? "text.brand" : "text.secondary"}>
              Next
            </Typography>
          </BasicButton>
        </Row>
        {tgUserId && tgUserName && variant !== "update" ? (
          <Typography
            sx={{ marginY: "20px" }}
            variant="pre-title-2"
            color="text.system-red"
            onClick={onClickLogout}>
            Logout
          </Typography>
        ) : (
          <></>
        )}
      </Col>
    </>
  ) : (
    <>
      <Col
        type="cc"
        sx={{ padding: "16px", textAlign: "center", gap: "24px" }}
        fullWidth
        fullHeight>
        <Typography sx={{ marginBottom: "34px", maxWidth: "230px" }} variant="mobile-h2">
          Enter the security one-time code
        </Typography>
        <Box
          sx={{
            textAlign: "start",
            maxWidth: "372px",
            width: "100%",
          }}>
          <Box sx={{ marginBottom: "4px" }}>
            <Typography variant="mobile-body-s" color="text.secondary">
              One-time security code
            </Typography>
          </Box>
          <StyledInputV2 key="otp" onChange={handleOnOTPChange} sx={{ textAlign: "start" }} />
          <Typography variant="mobile-body-s" color="brand.primary">
            A one-time security code is sent to {email}.
          </Typography>
        </Box>
        <Box
          sx={{
            position: "relative",
            marginX: "auto",
            height: "56px",
            maxWidth: "372px",
            width: "100%",
            // paddingX: "12px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            gap: "12px",
          }}>
          <BasicButton sx={{ width: "100%" }} variant="white" onClick={handleGoBack}>
            <Typography variant="mobile-body-s-heavy">Go Back</Typography>
          </BasicButton>
          <BasicButton
            sx={{ width: "100%" }}
            variant={isOtpValid && !isOtpVerifying ? "primary" : "disabled"}
            onClick={handleVerifyOTP}
            disabled={!isOtpValid || isOtpVerifying}>
            <Typography
              variant="mobile-body-s-heavy"
              color={isOtpValid && !isOtpVerifying ? "text.brand" : "text.secondary"}>
              Confirm
            </Typography>
          </BasicButton>
        </Box>
        {tgUserId && tgUserName && variant !== "update" ? (
          <Typography
            sx={{ marginY: "20px" }}
            variant="pre-title-2"
            color="text.system-red"
            onClick={onClickLogout}>
            Logout
          </Typography>
        ) : (
          <></>
        )}
      </Col>
    </>
  );
};

const TYPOGRAPHY_BODY_MD = (theme: Theme) => ({
  ...theme.typography["body-default"],
});

const StyledInputV2 = styled("input")(({ theme }) => ({
  width: "100%",
  height: "46px",
  textAlign: "end",
  backgroundColor: theme.palette.surface.black,
  border: `1px solid ${theme.palette.border.light}`,
  borderRadius: "8px",
  padding: "0 12px",
  opacity: "0.5",
  color: theme.palette.text.primary,
  ...TYPOGRAPHY_BODY_MD(theme as Theme),
  "&:focus, &:not(:placeholder-shown)": {
    opacity: "1",
    outline: "none",
  },
  "&::placeholder": {
    color: theme.palette.text.primary,
  },
}));
